import * as React from 'react';
import styled, { CSSObject } from 'styled-components';

export interface NoBordersTableProps {
  children: React.ReactNode;
  tableStyle?: React.CSSProperties;
}

export const NoBordersTable: React.FC<NoBordersTableProps> = ({
  children,
  tableStyle,
}) => {
  return (
    <StyledTable style={tableStyle} cellPadding={0} cellSpacing={0}>
      {children}
    </StyledTable>
  );
};

const StyledTable = styled.table`
  margin: 0;
  width: 100%;
  border-collapse: collapse;
`;

export const StyledTd = styled.td<{
  weight?: 'light' | 'dark';
  innerPStyle?: CSSObject;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: ${(props) => (props.weight === 'light' ? '400' : '500')};
  font-size: 12px;
  height: 30px;
  letter-spacing: -0.01em;
  p {
    ${(props) => (props.innerPStyle ? props.innerPStyle : '')}
  }
`;

export const StyledTh = styled.th<{
  width?: string;
  size?: 'small' | 'large';
  color?: string;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  text-align: left;
  font-weight: 500;
  font-size: 10px;
  line-height: 11px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  height: 30px;
  color: ${(props) =>
    props.color ?? props.theme.atlas.semantic.color.type.disabled};
  border-collapse: separate;
  border-spacing: 0;
  ${(props) => (props.width ? `width: ${props.width};` : '')}
`;

export const StyledThead = styled.thead`
  position: relative;
`;
